export default __webpack_public_path__ + "static/media/kinderland3.aa3a3283.png";